import Icon from 'vue-awesome/components/Icon.vue';
Icon.register({
  scanSimple: {
    width: 100,
    height: 100,
    d: `M90.05,10.32V39.46H75.27V53.83H60.91v3.55H39.24V90H10.09V60.89H24.93v-6.8H10.16V10.32H39.31V39.46H25v7.12H60.91V32.34H51.7V18h9.21V10.32ZM75.55,68.21H46.37V90H57.18V75.46h7.56V90H90.05V79.12H79.17V68.21H90.05V53.7H75.55Z`,
  },
});
